function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { useContrastText } from "../../Colors/useContrastText";
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { useMemo } from "react";
export function useStyle(props) {
    var scaleValue = function scaleValue(propertySize, initialSize, componentSize) {
        return "".concat(propertySize * componentSize / initialSize, "rem");
    };
    var backgroundColor = props.backgroundColor, border = props.border, borderColorOverride = props.borderColorOverride, editScrim = props.editScrim, formatTextOverride = props.formatTextOverride, hoverScrim = props.hoverScrim, hoverShadow = props.hoverShadow, indicator = props.indicator, isRtl = props.isRtl, length = props.length, size = props.size, square = props.square, textColorOverride = props.textColorOverride;
    var textColor = useContrastText({
        background: backgroundColor,
        foreground: _toConsumableArray(typeof textColorOverride === 'string' ? [
            textColorOverride
        ] : textColorOverride).concat([
            'rgb(255,255,255)',
            'rgb(0,0,0)'
        ]),
        compliance: 'AA',
        size: size < 3 ? 'small' : 'large'
    });
    var ref = _slicedToArray(((indicator === null || indicator === void 0 ? void 0 : indicator.position) === undefined ? 'bottom-end' : indicator.position).split('-'), 2), verticalPosition = ref[0], horizontalPositionKey = ref[1];
    var indicatorOffset = square ? "calc((-".concat(size, "rem / 32) - (").concat(size, "rem / 32))") : "calc(-".concat(size, "rem / 32)");
    var horizontalPositionMap = isRtl ? {
        start: 'right',
        end: 'left'
    } : {
        start: 'left',
        end: 'right'
    };
    var horizontalPosition = horizontalPositionMap[horizontalPositionKey];
    var borderSize = scaleValue(8, 128, size);
    var ref1;
    var ref2 = (ref1 = useBuildStyleWithTheme(buildStyle)) !== null && ref1 !== void 0 ? ref1 : {}, actionContainer = ref2.actionContainer, scrimAndShadowOnHover = ref2.scrimAndShadowOnHover, imageContainer = ref2.imageContainer, indicatorContainer = ref2.indicatorContainer, indicatorVariant = ref2.indicatorVariant, mainContainer = ref2.mainContainer, scrimOnHover = ref2.scrimOnHover, shadowOnHover = ref2.shadowOnHover, wrapper = ref2.wrapper;
    return useMemo(function() {
        var _obj;
        return {
            wrapper: _objectSpread({}, wrapper === null || wrapper === void 0 ? void 0 : wrapper.base, {
                width: "".concat(size, "rem"),
                height: "".concat(size, "rem")
            }),
            mainContainer: _objectSpread({}, mainContainer === null || mainContainer === void 0 ? void 0 : mainContainer.base, {
                color: textColor,
                backgroundColor: backgroundColor
            }, border ? {
                borderWidth: borderSize,
                borderStyle: 'solid'
            } : {
                border: 'none'
            }, border && borderColorOverride && {
                borderColor: borderColorOverride
            }, square ? {
                borderRadius: scaleValue(17, 128, size)
            } : mainContainer === null || mainContainer === void 0 ? void 0 : mainContainer.circle, editScrim && (mainContainer === null || mainContainer === void 0 ? void 0 : mainContainer.hover), formatTextOverride ? {
                fontSize: length > 2 ? "".concat(size / length, "rem") : scaleValue(64, 128, size)
            } : {
                fontSize: scaleValue(64, 128, size)
            }, isRtl && (mainContainer === null || mainContainer === void 0 ? void 0 : mainContainer.rtl), hoverShadow && shadowOnHover, hoverScrim && scrimOnHover, hoverShadow && hoverScrim && scrimAndShadowOnHover),
            imageContainer: imageContainer === null || imageContainer === void 0 ? void 0 : imageContainer.base,
            loadingImageContainer: _objectSpread({}, imageContainer === null || imageContainer === void 0 ? void 0 : imageContainer.base, imageContainer === null || imageContainer === void 0 ? void 0 : imageContainer.loading),
            actionContainer: _objectSpread({}, actionContainer === null || actionContainer === void 0 ? void 0 : actionContainer.base, {
                height: scaleValue(42, 128, size)
            }),
            actionIcon: _objectSpread({}, actionContainer === null || actionContainer === void 0 ? void 0 : actionContainer.icon, {
                height: scaleValue(42, 128, size)
            }),
            indicatorContainer: _objectSpread({}, indicatorContainer, {
                width: "calc(".concat(size, "rem / 4)"),
                height: "calc(".concat(size, "rem / 4)"),
                borderWidth: "calc((".concat(size, "rem + ").concat(borderSize, " * 2) / 32)")
            }, (indicator === null || indicator === void 0 ? void 0 : indicator.color) && (indicatorVariant === null || indicatorVariant === void 0 ? void 0 : indicatorVariant[indicator.color]), (_obj = {}, _defineProperty(_obj, horizontalPosition, indicatorOffset), _defineProperty(_obj, verticalPosition, indicatorOffset), _obj))
        };
    }, [
        actionContainer,
        backgroundColor,
        border,
        borderColorOverride,
        borderSize,
        editScrim,
        formatTextOverride,
        horizontalPosition,
        hoverScrim,
        hoverShadow,
        imageContainer,
        indicator,
        indicatorContainer,
        indicatorOffset,
        indicatorVariant,
        isRtl,
        length,
        mainContainer,
        scrimAndShadowOnHover,
        scrimOnHover,
        shadowOnHover,
        size,
        square,
        textColor,
        verticalPosition,
        wrapper
    ]);
}
function buildStyle(theme, direction, param) {
    var typographyUpdates = param.typographyUpdates;
    var ref = theme.depth.boxShadow[2], xOffset = ref.xOffset, yOffset = ref.yOffset, blurRadius = ref.blurRadius, spreadRadius = ref.spreadRadius, color = ref.color;
    var boxShadow = "".concat(xOffset, " ").concat(yOffset, " ").concat(blurRadius, " ").concat(spreadRadius, " ").concat(color);
    var backgroundColor = theme.backgroundColor, border = theme.size.border, font = theme.font, borderColor = theme.borderColor;
    return {
        wrapper: {
            base: {
                borderRadius: border.radius.round,
                position: 'relative',
                '&:focus-within': {
                    outline: 'none',
                    boxShadow: "0 0 0 ".concat(theme.size.border.focus, "px ").concat(theme.borderColor.brand.focus)
                }
            }
        },
        mainContainer: {
            base: {
                height: '100%',
                width: '100%',
                position: 'relative',
                borderColor: borderColor.soft,
                fontFamily: font.base.family,
                fontWeight: typographyUpdates ? font.base.weight.regular : font.base.weight.light,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                overflow: 'hidden',
                boxSizing: 'border-box'
            },
            circle: {
                borderRadius: border.radius.round
            },
            hover: {
                cursor: 'pointer'
            },
            rtl: {
                direction: 'rtl'
            }
        },
        imageContainer: {
            base: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                objectFit: 'cover',
                width: '100%',
                height: '100%'
            },
            loading: {
                visibility: 'hidden'
            }
        },
        actionContainer: {
            base: {
                width: '100%',
                position: 'absolute',
                bottom: '0',
                left: '0',
                backgroundColor: backgroundColor.warning.base,
                opacity: 0.5
            },
            icon: {
                width: '100%',
                position: 'absolute',
                bottom: '0',
                left: '0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                opacity: 1,
                fill: theme.font.color.base
            }
        },
        scrimOnHover: {
            '& div,span': {
                opacity: 0
            },
            '&:hover': {
                boxShadow: 'none',
                '& div': {
                    opacity: 0.5
                },
                '& span': {
                    opacity: 1
                }
            }
        },
        scrimAndShadowOnHover: {
            '&:hover': {
                boxShadow: boxShadow,
                '& div': {
                    opacity: 0.5
                },
                '& span': {
                    opacity: 1
                }
            }
        },
        shadowOnHover: {
            '&:hover': {
                boxShadow: boxShadow
            }
        },
        indicatorContainer: {
            borderRadius: border.radius.round,
            color: backgroundColor.neutral.base,
            backgroundColor: backgroundColor.neutral.fill.base,
            borderStyle: 'solid',
            borderColor: backgroundColor.base,
            position: 'absolute'
        },
        indicatorVariant: {
            danger: {
                color: backgroundColor.danger.base,
                backgroundColor: backgroundColor.danger.fill.base
            },
            warning: {
                color: backgroundColor.warning.base,
                backgroundColor: backgroundColor.warning.fill.base
            },
            success: {
                color: backgroundColor.success.base,
                backgroundColor: backgroundColor.success.fill.base
            },
            accent: {
                color: backgroundColor.accent.base,
                backgroundColor: backgroundColor.accent.fill.base
            },
            brand: {
                color: backgroundColor.brand.base,
                backgroundColor: backgroundColor.brand.fill.base
            },
            tertiary: {
                color: backgroundColor.tertiary.base,
                backgroundColor: backgroundColor.tertiary.fill.base
            },
            interactive: {
                color: backgroundColor.interactive.base,
                backgroundColor: backgroundColor.interactive.fill.base
            },
            neutral: {
                color: backgroundColor.neutral.base,
                backgroundColor: backgroundColor.neutral.fill.base
            }
        }
    };
}
